namespace $.$$ {

	export class $shm_hitalama_map_widget_float_form extends $.$shm_hitalama_map_widget_float_form {

		@ $mol_mem
		form() {
			return this.widget().form()!
		}

	}

}
